var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"circle progress-bar",style:('background-image: ' + _vm.backgroundImage)},[_c('div',{staticClass:"overlay",style:('background-color: ' + _vm.backgroundColor + '; color: ' + _vm.color)},[_c('span',[_vm._v(_vm._s(_vm.animatedValue+'%'))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-828d929a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vuestic-theme/vuestic-components/vuestic-progress-bar/progress-types/CircleProgressBar.vue
// module id = g6j3
// module chunks = 364